import React, { useEffect, useState } from 'react';
import ViewReverse from './ViewReverse';
import { ReactSVG } from 'react-svg';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import dynamicfunction from '../utils/dynamicfunction';
import icons from '../constants/icons';
import ViewItems from './ViewItems';
import { useSelector } from 'react-redux';
import { cn, getContentKeyAccToLang, getMenuList } from '../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { clientSuspendedToast } from '../utils/functions';

const Sidebar = ({ children }) => {
  const pathname = useLocation();
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();

  const { user } = useSelector((state) => state.common);
  const { dashboardContent } = useSelector((state) => state.content);

  const [menuList, setMenuList] = useState([]);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  useEffect(() => {
    const list = getMenuList(pathname?.pathname);
    setMenuList(list);
  }, [pathname]);

  const onPressMenu = (route) => navigate(route);

  return (
    <div className={'grid grid-cols-12 flex-1'}>
      <div
        className={cn(
          isArabic ? 'order-2' : 'order-1',
          user ? 'col-span-2 xl:col-span-3' : 'hidden'
        )}
      >
        {menuList?.map((item, index) => {
          const is_disabled = user ? false : true;
          const is_suspend = item?.suspendedRoute && user?.isClientSuspended
          return (
            <div
              key={index}
              className={cn(
                'px-2 py-4 lg:px-6 lg:py-8 border-b border-b-grey',
                item?.isDisabled
                  ? 'opacity-50 cursor-not-allowed'
                  : is_disabled && index !== 0
                    ? 'opacity-50 cursor-not-allowed'
                    : 'opacity-100 cursor-pointer'
              )}
              onClick={() => {
                if (is_suspend) {
                  clientSuspendedToast(isArabic)
                } else if (item?.childs?.length > 0 && item?.isActive) {
                } else {
                  if (!is_disabled && !item?.isDisabled) {
                    onPressMenu(item?.route);
                  }
                }
              }}
            >
              <ViewReverse className={`gap-1 sm:gap-3 items-center`}>
                <ReactSVG
                  src={item?.isActive ? item?.activeIcon : item?.disableIcon}
                  className='scale-75 md:scale-100'
                />
                <Text
                  text={getContentKey(item?.key)}
                  size={fontSizes.h14}
                  isTruncate={false}
                  weight={
                    item?.isActive ? TextWeight.regular : TextWeight.light
                  }
                  color={`${item?.isActive ? 'text-primary' : 'text-dark-grey'
                    }`}
                  className={'hidden lg:block'}
                />
                {item?.childs?.length > 0 && (
                  <ReactSVG
                    src={
                      item?.isActive ? icons.upArrowSelected : icons.downArrow
                    }
                  />
                )}
              </ViewReverse>
              {item?.isActive && item?.childs?.length > 0 && (
                <ViewItems className={'mt-2 ms-8'}>
                  {item?.childs?.map((child) => {
                    return (
                      <div
                        onClick={() => onPressMenu(child?.route)}
                        className='cursor-pointer'
                        key={child?.key}
                      >
                        <Text
                          text={getContentKey(child.key)}
                          size={fontSizes.h14}
                          weight={
                            child?.isActive ? TextWeight.bold : TextWeight.light
                          }
                          color={
                            child?.isActive ? 'text-primary' : 'text-dark-grey'
                          }
                          className={`hidden lg:block my-1`}
                          isTruncate={false}
                        />
                      </div>
                    );
                  })}
                </ViewItems>
              )}
            </div>
          );
        })}
      </div>
      <div
        className={cn(
          'h-full bg-white p-4 md:p-8',
          isArabic ? 'order-1 md:ps-24' : 'order-2 md:pe-24',
          user ? 'col-span-10 xl:col-span-9' : 'col-span-12 md:px-24'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
